import Flickity from "flickity";
import "jquery-match-height";

const spaceStorageOptions = $("#space-storage").find(".space");
const acSpaceStorageOptions = $("#space-storage").find(".ac-space");
const specialStorageOptions = $("#space-storage").find(".special");

const defaultSettings = {
  cellAlign: "center",
  autoPlay: 8000,
  groupCells: true,
  draggable: true,
  pageDots: true,
  prevNextButtons: false,
  wrapAround: true,
};

const itemStorageFlick = new Flickity("#item-storage", {
  ...defaultSettings,
  on: {
    ready: function () {
      $("#item-storage .img-container").matchHeight();
    },
  },
});

$(".item-storage-container")
  .on("click", ".arrows.prev", () => {
    itemStorageFlick.previous();
    return true;
  })
  .on("click", ".arrows.next", () => {
    itemStorageFlick.next();
    return true;
  });

const spaceStorageFlick = new Flickity("#space-storage", {
  ...defaultSettings,
  on: {
    ready: function () {
      $("#space-storage .img-container").matchHeight();
    },
  },
});

$(".space-storage-container")
  .on("click", ".arrows.prev", () => {
    spaceStorageFlick.previous();
    return true;
  })
  .on("click", ".arrows.next", () => {
    spaceStorageFlick.next();
    return true;
  });

const modalTypeChanger = (element) => {
  const anchor = $(element).find("a");
  const modalId = anchor.attr("href");
  const size = anchor.data("size");

  if (!modalId || !size) {
    return;
  }

  const body = $(modalId).find(".modal-body .types");

  body.children().hide();
  body.find(`#${size}`).show();

  $(modalId).modal("show");
};

spaceStorageFlick.on(
  "staticClick",
  function (event, pointer, element, cellIndex) {
    if (!element) {
      return;
    }

    modalTypeChanger(element);
  }
);

itemStorageFlick.on(
  "staticClick",
  function (event, pointer, element, cellIndex) {
    if (!element) {
      return;
    }

    modalTypeChanger(element);
  }
);

const filterSpaceStorage = function (option, transition = true) {
  const container = $("#space-storage");
  const cells = spaceStorageFlick.getCellElements();

  if (transition) {
    container.find(".flickity-slider").css("opacity", 0);
  }

  setTimeout(() => {
    spaceStorageFlick.remove(cells);

    if (option === "space-storage") {
      spaceStorageFlick.append(spaceStorageOptions);
    } else if (option === "ac-space-storage") {
      spaceStorageFlick.append(acSpaceStorageOptions);
    }

    spaceStorageFlick.append(specialStorageOptions);
    spaceStorageFlick.select(0, true, true);
    spaceStorageFlick.reposition();

    container.find(".img-container").matchHeight();

    if (transition) {
      container.find(".flickity-slider").css({
        opacity: 1,
        transition: "opacity 0.3s ease-in-out",
      });
    }
  }, 300);
};

filterSpaceStorage("space-storage", false);

$("ul#space-storage-options").on("click", "a.storage-option", function (e) {
  e.preventDefault();

  const parent = $(this).parent("li");
  const currentActive = parent.siblings("li.active");
  const option = $(this).data("option");

  if (currentActive.find("a").data("option") !== undefined) {
    currentActive.removeClass("active");

    currentActive.removeClass("active");
    parent.addClass("active");

    filterSpaceStorage(option);
  }
});

$("#modal-item-storage, #modal-space-storage, #modal-ac-space-storage")
  .on("shown.bs.modal", function () {
    $(this).find(".modal-body").css("opacity", 1);
  })
  .on("hide.bs.modal", function () {
    $(this).find(".modal-body").css("opacity", 0);
  });
